import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login'
import Join from './pages/Join';
import ProfileSettings from './pages/ProfileSettings';
import { Dashboard } from './pages';
import Auth from './lib/Auth';
import ToastProvider from './components/modals/ToastProvider';
import ThemeManager from './contexts/ThemeManager';
import { GoogleOAuthProvider } from '@react-oauth/google';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <ThemeManager>
      <ToastProvider>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/dashboard" element={<Auth><Dashboard /></Auth>} />
          <Route path="/login" element={<GoogleOAuthProvider clientId="173610420719-9n6fcm6g0neq6vd4uuae312fd1dm3ulu.apps.googleusercontent.com"><Login /></GoogleOAuthProvider>} />
          <Route path="/profile" element={<Auth><ProfileSettings /></Auth>} />
          <Route path="/join/*" element={<Join />} />
        </Routes>
      </ToastProvider>
    </ThemeManager>
  </BrowserRouter>
);
